import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../../data.service';

@Component({
  selector: 'lc-account-create-page',
  templateUrl: './account-create-page.component.html',
  styleUrls: ['./account-create-page.component.scss']
})
export class AccountCreatePageComponent implements OnInit {

  verified_email: string;
  activation_code: string;
  mode: string = 'create';
  optout_params = {};

  constructor(public dataService: DataService, private route: ActivatedRoute) { }

  ngOnInit() {
    try { window['set_page_name']('account_create_page') } catch (e) { };
    this.checkStatus();
  }

  checkStatus() {
    this.route.params.subscribe(params => {
      let uid = params['uid'];
      let email = params['email'];    // N.B. in case of optout we use the numeric user ID here, so NOT display the email !
      let token = params['token'];
      let activation_code = params['code'];
      let unsub_r = params['r'];
      let unsub_h = params['h'];
      let unsub_t = params['t'];
      
      if (!!email && !!unsub_r && !!unsub_h && !!unsub_t) {
        this.optout_params = { id: email, r: unsub_r, h: unsub_h };
        // this.mode = 'optout';
        this.optout_params['optin_'+ unsub_t] = false;
        this.dataService.update_user(this.optout_params).subscribe(
          sub_user => {
            this.dataService.subuser_info = sub_user;
            this.dataService.is_verified = true;
            this.dataService.is_logged_in = false;

            this.dataService.presentMessage('Uw e-mailadres is afgemeld!', 'success', 0);
            // prefill this email ...
          },
          error => {
            this.dataService.presentMessage('Sorry! Deze afmeld link is niet geldig.', 'Error', 0);
          }
        );
        return;
      }
      if (!!email && !!token) {
        this.dataService.reset_params = { email: email, token: token };
        this.mode = 'reset';
      }
      if (!!activation_code) {
        this.activation_code = activation_code;
      }

      if (!!uid && !!token) {
        this.dataService.verify_user(uid, token).subscribe(
          sub_user => {
            this.dataService.subuser_info = sub_user;
            this.dataService.is_verified = true;
            this.dataService.is_logged_in = false;

            this.dataService.presentMessage('Uw e-mailadres is gecontroleerd en correct!', 'Success');
            // prefill this email ...
            this.verified_email = this.dataService.subuser_info.email;
          },
          error => {
            this.dataService.presentMessage('Sorry! Deze activatielink is niet geldig.', 'Error');
          });
      }
    });
  }


}


// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/account-create-page/account-create-page.component.ts